import type { TaxonomyTerm } from "@/types/taxonomy";

export type ServiceDelivery = "VIRTUAL" | "IN_PERSON" | "HYBRID";
export type AvailabilityStatus = "ACCEPTING" | "LIMITED" | "WAITLIST" | "NOT_ACCEPTING";

export interface TherapistSummary {
  id: string; firstName: string; lastName: string; credentials: string | null;
  pronouns: string | null; photoUrl: string | null; slug: string;
  availabilityStatus: AvailabilityStatus; focusAreas: TaxonomyTerm[];
  modalities: TaxonomyTerm[]; demographics: TaxonomyTerm[]; sortOrder: number;
}

export interface TherapistDetail extends TherapistSummary {
  userId: string | null; staffMemberId: string | null; bio: string | null;
  yearsOfExperience: number | null; education: string | null; licensure: string | null;
  serviceDelivery: ServiceDelivery; schedulingUrl: string | null;
  bookingPlatformRef: string | null; metaTitle: string | null;
  metaDescription: string | null; ogImageUrl: string | null;
  canonicalUrl: string | null; published: boolean;
}

export interface TherapistRequest {
  userId?: string | null; staffMemberId?: string | null; firstName: string; lastName: string;
  credentials?: string; pronouns?: string; photoUrl?: string; slug: string; bio?: string;
  yearsOfExperience?: number; education?: string; licensure?: string;
  serviceDelivery: ServiceDelivery; availabilityStatus: AvailabilityStatus;
  schedulingUrl?: string; bookingPlatformRef?: string; metaTitle?: string;
  metaDescription?: string; ogImageUrl?: string; canonicalUrl?: string;
  published: boolean; sortOrder: number; termIds: string[];
}

export interface TherapistFilters { focusArea?: string; modality?: string; demographic?: string; delivery?: ServiceDelivery; availability?: AvailabilityStatus; q?: string }

export const SERVICE_DELIVERY_LABELS: Record<ServiceDelivery, string> = { VIRTUAL: "Virtual", IN_PERSON: "In person", HYBRID: "Hybrid" };
export const AVAILABILITY_LABELS: Record<AvailabilityStatus, string> = { ACCEPTING: "Accepting new clients", LIMITED: "Limited availability", WAITLIST: "Waitlist", NOT_ACCEPTING: "Not accepting clients" };
